(function() {
    $(document).ready(function() {

        window.c24LpCssLoaded.then(function () {

            const menuEntries = $('a[data-menu]');
            const flexibleContent = $('.panels-flexible-row');
            let isFlex = false;

            if (flexibleContent.length > 0) {
                isFlex = true;
            }

            if (menuEntries.length < 2) {
                return;
            }

            (function () {

                return {
                    sPosition: isFlex ? 'left' : 'right',
                    menuEntries: menuEntries,
                    headerHeight: $('#c24-page-container-header').outerHeight(true),
                    minContentWidth: 1200,
                    lastcontentWidth: 0,
                    contentWidth: 0,
                    childItems: null,
                    parentItem: null,
                    allParentsItems: null,
                    allChildrenItems: null,
                    sidebarNav: null,
                    prevScroll: null,
                    prevTime: null,
                    timeOut: null,
                    init: function () {

                        if (this.menuEntries.length < 2) {
                            return;
                        }

                        const $this = this;

                        this.createMenu();
                        this.parentClickEvents();
                        this.arrangeSidebarHeightPosition();

                        $(window).resize(function () {
                            $this.arrangeSidebarWidthPosition();
                        });

                        $(window).on('scroll', function () {
                            $this.arrangeSidebarHeightPosition();
                        });

                    },
                    createMenu: function () {

                        if (this.menuEntries.length > 2) {
                            const menuList = this.menuEntries;
                            const flexClassName = isFlex ? ' flexibleDesign' : '';
                            let html = '<aside class="mod24SidebarNav' + flexClassName + '"><nav>';
                            let itemCount = 0;
                            let isUlTagOpen = false;
                            html += '<ul>';

                            $.each(menuList, function () {
                                let $this = $(this);
                                let id = $this.attr('id');
                                let caption = $this.data('menu');

                                if ($this.data('deviceoutput') === 'mobile') {
                                    return;
                                }

                                if ($this.data('submenu')) {
                                    html += '<li class="childItem"><a href="#' + id + '">' + $('<div />').html(caption).text() + '</a></li>';
                                } else {
                                    if (isUlTagOpen) {
                                        html += '</ul></li>';
                                        isUlTagOpen = false;
                                    }
                                    html += '<li><ul><li class="parentItem"><a href="#' + id + '">' + $('<div />').html(caption).text() + '</a></li>';
                                    isUlTagOpen = true;
                                }

                                itemCount++;
                            });

                            if (isUlTagOpen) {
                                html += '</ul></li>';
                                isUlTagOpen = false;
                            }

                            html += '</ul>';

                            if (itemCount < 3) {
                                return;
                            }

                            html += '</nav></aside>';

                            $('#c24-page-content').append($(html));

                            this.childItems = null;
                            this.sidebarNav = $('.mod24SidebarNav');
                            this.allParentsItems = $('.mod24SidebarNav .parentItem');
                            this.allChildrenItems = $('.mod24SidebarNav .childItem');

                            $.each(this.allParentsItems, function () {
                                const childItems = $(this).nextAll('li');
                                if (childItems.length > 0) {
                                    $(this).addClass('collapsible');
                                }
                            });
                            this.allChildrenItems.hide();
                        }
                    },
                    parentClickEvents: function () {


                        const self = this;

                        $(this.allParentsItems).on('click', function ()
                        {
                            if ($(this).hasClass('active') || $(this).hasClass('semiactive')) {

                                if ($(this).hasClass('closed')) {
                                    self.showChildrenOfParent($(this));
                                    $(this).removeClass('closed');

                                } else {
                                    self.hideChildrenOfParent($(this));
                                    $(this).addClass('closed');
                                }
                            }
                        });

                    },
                    sidebarScroollingEvents: function (fittingClass) {

                        let oldParent;
                        let newParent;
                        let isChild;

                        if (fittingClass.hasClass('childItem')) {
                            newParent = fittingClass.parent().find('.parentItem');
                            isChild = true;
                        } else {
                            newParent = fittingClass;
                            isChild = false;
                        }

                        oldParent = this.prevScroll;
                        this.prevScroll = newParent;

                        if (oldParent !== null) {
                            this.closeOtherParentIfNeeded(oldParent, newParent);
                        }

                        newParent = fittingClass.parent().find('.parentItem');

                        if (isChild && ! newParent.hasClass('closed')) {
                            this.openCurrentParentIfNeeded(newParent, 'semiactive');
                            fittingClass.addClass('active');
                        } else {
                            this.openCurrentParentIfNeeded(newParent, 'active');
                        }

                    },
                    hideChildrenOfParent: function(parent) {
                        const hideChildItems = parent.nextAll('.childItem');
                        hideChildItems.stop().fadeOut('fast');
                    },
                    showChildrenOfParent: function(parent) {
                        const hideChildItems = parent.nextAll('.childItem');
                        hideChildItems.stop().fadeIn('fast');
                    },
                    closeOtherParentIfNeeded: function(oldParent, newParent) {

                        if (oldParent[0] === newParent[0]) {
                            if (! newParent.hasClass('closed')) {
                                this.showChildrenOfParent(oldParent);
                            }
                            return;
                        }

                        this.hideChildrenOfParent(oldParent);

                        oldParent.removeClass('closed active semiactive');
                        oldParent.nextAll('.childItem').removeClass('active');
                    },
                    openCurrentParentIfNeeded: function(newParent, className) {

                        const hideChildItems = newParent.nextAll('.childItem');
                        hideChildItems.removeClass('active');

                        newParent.removeClass('active semiactive');
                        newParent.addClass(className);

                        if (! newParent.hasClass('closed')) {
                            this.showChildrenOfParent(newParent);
                        }
                    },
                    arrangeSidebarWidthPosition: function () {

                        this.contentWidth = $('#c24-page-content').width();

                        if (this.lastcontentWidth === this.contentWidth) {
                            return;
                        }

                        const navWidth = this.sidebarNav.width();
                        const extraPadding = isFlex ? 70 : 130;

                        if (this.contentWidth >= (this.minContentWidth + (navWidth * 2) + 75)) {
                            this.sidebarNav.css(this.sPosition, ((this.contentWidth - (this.minContentWidth + (navWidth * 2) + extraPadding)) / 3) + 'px');
                            this.sidebarNav.show();

                        } else {
                            this.sidebarNav.hide();
                        }
                    },
                    arrangeSidebarHeightPosition: function () {

                        this.arrangeSidebarWidthPosition();

                        let fixedComponentIpss = $('.ipssNewCompareBox');
                        let fixedComponentFixed = $('.js24Fixable.js24Fixed');

                        let fixableHeight = Math.max(
                            fixedComponentIpss.length ? fixedComponentIpss.outerHeight(false) : 0,
                            fixedComponentFixed.length ? fixedComponentFixed.outerHeight(false) : 0,
                        );

                        let scrollTop = $(window).scrollTop();
                        let linkedOffset = null;
                        let link = null;
                        let minVerticalPos = null;
                        let fittingLink = null;
                        let fittingClass = null;

                        if (scrollTop > ($(document).height() - $(window).height() - 100)) {
                        // The last element might be so short that it might never be on top.
                            fittingLink = $('nav a', this.sidebarNav).last();
                        } else {
                            $.each(
                                $('nav a', this.sidebarNav),
                                function () {
                                    link = $(this);
                                    linkedOffset = $(link.attr('href')).offset().top;
                                    if (minVerticalPos === null) {
                                        minVerticalPos = linkedOffset;
                                    }
                                    if (linkedOffset <= (scrollTop + fixableHeight + 20) || fittingLink === null) {
                                        fittingLink = link;
                                    }
                                },
                            );
                            if (scrollTop + fixableHeight + 20 <= minVerticalPos) {
                                this.sidebarNav.css('position', 'absolute');
                                this.sidebarNav.css('top', (minVerticalPos - this.headerHeight) + 'px');
                            } else {
                                this.sidebarNav.css('position', 'fixed');
                                this.sidebarNav.css('top', (fixableHeight + 20) + 'px');

                            }
                        }

                        const now = window.performance.now();

                        if (this.prevTime === null || now - this.prevTime > 150) {
                            this.prevTime = now;

                            fittingClass = fittingLink.parent();
                            if (fittingClass === null) {
                                return;
                            }
                            this.sidebarScroollingEvents(fittingClass);

                        } else {

                            if (this.timeOut) {
                                return;
                            }

                            const self = this;
                            self.timeOut = window.setTimeout(function () {
                                self.timeOut = null;
                                self.arrangeSidebarHeightPosition();
                            }, 100);
                        }
                    },
                };
            }
            )().init();
        });
    });
})();
